import { render } from "./DocMermaid.vue?vue&type=template&id=c353d646"
import script from "./DocMermaid.vue?vue&type=script&lang=js"
export * from "./DocMermaid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__